import {FETCH_ACTIVE_SHIPPER_USERS} from '../actions/types';

const filterDrivers = (usersPayload) => {
    const driversPayload ={}
    if (usersPayload){
        Object.values(usersPayload).filter(user => (user.role_types || []).includes("role_driver")).map(user => {
            driversPayload[user.id] = user
        })
    }
    return driversPayload

}

export default (state = {}, action) => {
    switch(action.type) {
        case FETCH_ACTIVE_SHIPPER_USERS:
            return {...state, activeUsers: action.payload != undefined  ? action.payload : {},
                activeDrivers: action.payload != undefined ? filterDrivers(action.payload) : {}}
        default:
            return state;
    }
};